"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Form = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _reactstrap = require("reactstrap");
var _reactHookForm = require("react-hook-form");
var _definitions = require("@ppay/definitions");
var _ui = require("../../../../ui");
var _fields = require("../../../../fields");
var _hooks = require("../../../../../hooks");
var _TickerConverter = require("./TickerConverter");
var _TickerGroup = require("./TickerGroup");
var _ToTickerGroup = require("./ToTickerGroup");
var _NetworkGroup = require("./NetworkGroup");
var _BalanceGroup = require("./BalanceGroup");
var _FiatForm = require("./FiatForm");
var _ModeTabsNav = require("../../withdraw/ModeTabsNav");
var _SubmitButton = require("../SubmitButton");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var Form = function Form(_ref) {
  var children = _ref.children,
    balanceName = _ref.balanceName;
  var _useTranslation = (0, _reactI18next.useTranslation)(['libTransfers', 'libCommon']),
    t = _useTranslation.t;
  var _useFormContext = (0, _reactHookForm.useFormContext)(),
    control = _useFormContext.control,
    handleSubmit = _useFormContext.handleSubmit;
  var props = (0, _hooks.useExchangeContext)();
  if (_definitions.FIAT_TICKERS.includes(props.toTicker)) return /*#__PURE__*/_react.default.createElement(_FiatForm.FiatForm, {
    balanceName: balanceName,
    noValidate: true
  }, children);
  return /*#__PURE__*/_react.default.createElement(_reactstrap.Form, {
    noValidate: true
  }, /*#__PURE__*/_react.default.createElement(_ModeTabsNav.ModeTabsNav, {
    activeTab: _ModeTabsNav.Mode.CONVERT,
    onTabChange: props.setMode
  }), props.loading ? /*#__PURE__*/_react.default.createElement(_ui.Spinner, {
    size: "lg",
    color: "primary"
  }) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, children, /*#__PURE__*/_react.default.createElement(_TickerGroup.TickerGroup, null), /*#__PURE__*/_react.default.createElement(_ui.Row, null, /*#__PURE__*/_react.default.createElement(_ui.Col, {
    xs: 12,
    md: 6
  }, /*#__PURE__*/_react.default.createElement(_ToTickerGroup.ToTickerGroup, null)), /*#__PURE__*/_react.default.createElement(_ui.Col, {
    xs: 12,
    md: 6
  }, /*#__PURE__*/_react.default.createElement(_NetworkGroup.NetworkGroup, null))), /*#__PURE__*/_react.default.createElement(_BalanceGroup.BalanceGroup, {
    balanceName: balanceName
  }), /*#__PURE__*/_react.default.createElement(_ui.FormGroup, null, /*#__PURE__*/_react.default.createElement(_ui.Label, null, t('walletAddress')), /*#__PURE__*/_react.default.createElement(_fields.InputField, {
    control: control,
    inputProps: {
      name: 'address',
      type: 'text',
      autoComplete: 'on'
    }
  })), /*#__PURE__*/_react.default.createElement(_TickerConverter.TickerConverter, null), /*#__PURE__*/_react.default.createElement(_SubmitButton.SubmitButton, {
    onClick: handleSubmit(props.toggleModal),
    afterTimeoutClick: handleSubmit(function () {
      props.getExchangeInfo();
    }),
    onComplete: props.clearInfoTimeout,
    onTick: props.setInfoTimeout,
    loading: props.formBtnLoading,
    timeout: props.infoTimeout
  }, props.exchangeInfo.data && props.isEnoughBalance ? props.infoTimeout && !props.exchangeInfo.loading ? t('send') : t('updatePrice') : t('calculate'))));
};
exports.Form = Form;